import { each } from 'lodash/fp'
import { combineActions } from 'redux-actions'
import { getActionTypes } from 'redux-axios-middleware'

export default function combineActionsSuper(...actionCreators) {
  const requestTypes = []
  const successTypes = []
  const failureTypes = []

  each((type) => {
    const types = getActionTypes({ type })
    // @ts-expect-error TS(2345) FIXME: Argument of type 'any' is not assignable to parame... Remove this comment to see the full error message
    requestTypes.push(types[0])
    // @ts-expect-error TS(2345) FIXME: Argument of type 'any' is not assignable to parame... Remove this comment to see the full error message
    successTypes.push(types[1])
    // @ts-expect-error TS(2345) FIXME: Argument of type 'any' is not assignable to parame... Remove this comment to see the full error message
    failureTypes.push(types[2])
  }, actionCreators)

  return [
    combineActions(...requestTypes),
    combineActions(...successTypes),
    combineActions(...failureTypes),
  ]
}
